import script from "./WorkspaceGroupsNestedUsersLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceGroupsNestedUsersLoader.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceGroupsNestedUsersLoader.vue?vue&type=style&index=0&id=6ed7cb0e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ed7cb0e"]])

export default __exports__